module.exports = __webpack_public_path__ + "img/Group 27.1a7e543f.svg";